module.exports = __webpack_public_path__ + "static/media/latest-added-products-white.e49fa2a5.svg";